var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoPlayer',{staticClass:"C-fragment-media--video-player",attrs:{"type":_vm.type,"data":_vm.content,"ads":_vm.ads}})}
var staticRenderFns = []

export { render, staticRenderFns }